
import { Component, Vue, Prop } from 'vue-property-decorator';
import { IPagination } from '@/types';
import { getClockInExport, getClockInList } from '@/api/clockInList';
import { UserModule } from '@/store/modules/user';
import { parseTime } from '@/utils/index';

@Component({
  name: 'ClockInList',
  components: {
  }
})

export default class extends Vue {
  private tableData: any = [{
    clock_list: {}
  }]
  private originStartTime: any = '';
  private originEndTime: any = '';
  private listLoading = false
  // 页面参数定义
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  handleCurrentChange(size:number) {
    this.pagination.currentPage = size
    this.getClockInList(this.formSearch);
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size
    this.getClockInList(this.formSearch);
  }

  private formSearch:any = {
    name: '',
    rangeTime: []
  }

  // 生命周期
  created() {
    this.init();
  }

  private init() {
    let timeNum = Date.parse(String(new Date())) / 1000 - 24 * 60 * 60 * 6;
    let originTime = new Date(timeNum * 1000);
    this.originStartTime = String(originTime);
    this.originEndTime = String(new Date());
    this.formSearch.name = '';
    this.formSearch.rangeTime = [this.originStartTime, this.originEndTime];
    this.getClockInList(this.formSearch);
  }

  // 考勤记录列表
  getClockInList(val?: any) {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      name: this.formSearch.name,
      size: this.pagination.pageSize,
      page: this.pagination.currentPage,
      start_time: parseTime(val.rangeTime[0], '{y}-{m}-{d}'),
      end_time: parseTime(val.rangeTime[1], '{y}-{m}-{d}')
    };
    getClockInList(params)
      .then(res => {
        if (res.data) {
          this.tableData = res.data.list;
          this.pagination.total = res.data.count;
        } else {
          this.tableData = [{
            clock_list: {}
          }];
          this.pagination.total = 0;
          this.pagination.currentPage = 1;
        }
        this.listLoading = false;
      })
      .catch(err => {
        this.listLoading = false;
        this.showErrorMsg(err.msg);
        this.tableData = [{
          clock_list: {}
        }];
        this.pagination.total = 0;
        this.pagination.currentPage = 1;
      });
  }

  // 导出考勤数据
  handleExport() {
    let params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_name: UserModule.getCompanyName,
      name: this.formSearch.name,
      start_time: parseTime(this.formSearch.rangeTime[0], '{y}-{m}-{d}'),
      end_time: parseTime(this.formSearch.rangeTime[1], '{y}-{m}-{d}')
    };
    getClockInExport(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // 点击搜索
  handleSearch() {
    // 判断时间选择
    this.pagination.currentPage = 1;
    this.getClockInList(this.formSearch);
  }

  // 清空搜索条件
  handleClearSearch() {
    this.pagination.currentPage = 1;
    this.formSearch.name = '';
    this.formSearch.rangeTime = [this.originStartTime, this.originEndTime]
    this.getClockInList(this.formSearch);
  }

  // hud 提示
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
